import { render } from "./SocialLine.vue?vue&type=template&id=54b5e679&scoped=true&lang=pug"
import script from "./SocialLine.vue?vue&type=script&lang=js"
export * from "./SocialLine.vue?vue&type=script&lang=js"

import "./SocialLine.vue?vue&type=style&index=0&id=54b5e679&lang=sass&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b5e679"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
